import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Title, Button, ButtonLabel, ArrowRight, Icon } from './TopicTout.style';

const TopicTout = ({ backgroundColor, title, linkLabel, icon }) => (
  <Wrapper color={backgroundColor}>
    <Icon src={icon.file.url} />
    <Title>{title}</Title>
    <Button>
      <ButtonLabel>{linkLabel}</ButtonLabel>
      <ArrowRight />
    </Button>
  </Wrapper>
);

TopicTout.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string,
      details: PropTypes.shape({
        size: PropTypes.number,
        image: PropTypes.shape({
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
      fileName: PropTypes.string,
    }),
  }).isRequired,
};

export default TopicTout;



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomeTouts/TopicTout/TopicTout.js